// extracted by mini-css-extract-plugin
export default {"page":"Info_page__-B4nM","card":"Info_card__QE80n"};